import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import Shell from "./Shell.jsx";
import BugErrorBoundary from "./BugErrorBoundary.jsx";
import { installBugReporter } from "./bugReporter.js";
import { initI18n } from "./i18n.jsx";
import { configureMobileViewport } from "./device.js";
import MobileViewNotice from "./MobileViewNotice.jsx";

configureMobileViewport();

// Capture global errors / rejections / console / render crashes before anything else runs.
installBugReporter();

// Load the language + translations before first paint so the UI renders in the right
// language (and direction) immediately. Falls back to English if the registry is unreachable.
const root = createRoot(document.getElementById("root"));
const render = () => root.render(<StrictMode><BugErrorBoundary><Shell /><MobileViewNotice /></BugErrorBoundary></StrictMode>);
initI18n().then(render).catch(render);
